import { Button } from "components";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { token } from "utils/common";
import { useAppContext } from "../appContent";
import { RightArrowIcon } from "../Icons";

const Navbar = () => {
  const { navbarRef } = useAppContext();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <nav
      ref={navbarRef}
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 rounded-full px-4 md:px-6 py-4 flex items-center justify-between w-[94%] md:w-[90%] max-w-7xl transition-all duration-500 gap-8`}
      role="navigation"
      aria-label="Main navigation"
      style={{
        backdropFilter: "blur(10px)",
        background: "rgba(255, 255, 255, 0.05)",
        border: `1px solid rgba(255, 255, 255, 0.10)`,
        boxShadow: `0 4px 16px 0 rgba(0, 0, 0, 0.10)`,
      }}
    >
      {/* Logo */}
      <Link to={"/"} className="flex items-center">
        <img
          className="hover:cursor-pointer"
          src="Logos/iconFullLogo.png"
          alt="fullLogo"
          width={120}
          height={40}
        />
      </Link>

      {/* Desktop Menu */}
      <ul className="hidden md:flex gap-8 text-white ml-auto">
        <Link
          to="/about-us"
          className="hover:text-gray-300 cursor-pointer"
          style={{ mixBlendMode: "difference" }}
        >
          About Us
        </Link>
        <Link
          to="/contact-us"
          className="hover:text-gray-300 cursor-pointer"
          style={{ mixBlendMode: "difference" }}
        >
          Contact Us
        </Link>
      </ul>

      <Button
        endIcon={<RightArrowIcon width={20} height={20} color="#fff" />}
        variant="contained"
        sx={{ borderRadius: 10 }}
        onClick={() => {
          navigate(token ? "/app/dashboard" : "/login");
        }}
      >
        {token ? "Get Started" : "Login / Register"}
      </Button>

      {/* Hamburger Menu Button */}
      <button
        type="button"
        className="flex md:hidden text-white focus:outline-none ml-auto hover:cursor-pointer"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-7 h-7"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          {menuOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      {/* Mobile Menu */}
      <div
        className={`absolute top-full left-0 w-full rounded-2xl mt-2 bg-[rgba(0,0,0,0.85)] backdrop-blur-md border border-white/10 flex flex-col items-center text-white transition-all duration-300 overflow-hidden ${
          menuOpen ? "max-h-80 py-4 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <Link
          to="/about-us"
          onClick={() => setMenuOpen(false)}
          className="py-3 w-full text-center hover:text-gray-300"
        >
          About Us
        </Link>
        <Link
          to="/contact-us"
          onClick={() => setMenuOpen(false)}
          className="py-3 w-full text-center hover:text-gray-300"
        >
          Contact Us
        </Link>
        <Button
          variant="landingBtn"
          endIcon={<RightArrowIcon width={20} height={20} color="#fff" />}
          onClick={() => {
            navigate(token ? "/app/dashboard" : "/login");
          }}
        >
          {token ? "Get Started" : "Login / Register"}
        </Button>
      </div>
    </nav>
  );
};

export default Navbar;
